import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { RegisteringUser } from "#/lib/carrot-api/types/RegisteringUser"
import { HttpStatusCodes } from "#/utils/HttpStatusCodes"

const registeringUserQueryKey = "getRegisteringUser"

export function useFetchRegisteringUser(guid: string) {
  return useQuery<RegisteringUser>({
    queryKey: [registeringUserQueryKey, guid],
    queryFn: async () => {
      await carrotClient.logout()
      return carrotClient.getRegisteringUser(guid)
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: buildCarrotApiRetryPolicy(3, [HttpStatusCodes.CONFLICT])
  })
}
